import {
    Box,
    Button,
    Divider,
    FormControl,
    FormControlLabel,
    Chip,
    InputLabel,
    Grid,
    InputAdornment,
    MenuItem,
    Select,
    Slider,
    Switch,
    TextField,
    Tooltip,
    Typography,
    useMediaQuery,
    FormHelperText
} from "@mui/material";
import { SketchPicker } from "react-color";
import React from "react";
import { useState } from "react";
import uploadImage from "../../images/BFSettings-ImageUpload.svg";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import ImageTooltip from "../../utils/UI/ImageTooltip";
import {
    bookingFlowLogo,
    bookingFlowHeadingOne,
    bookingFlowHeadingTwo,
    bookingFlowHeadingThree,
    defaultBrandingStates
} from "../../utils/Constants";
import { styled } from "@mui/material/styles";
import InfoTooltip from "../../utils/UI/InfoTooltip";

function getToolTipStyle() {
    const toolTipStyle = {
        height: "16px",
        width: "16px",
        cursor: "pointer"
    };
    return toolTipStyle;
}

const fontPixels = () => {
    // 0 to 100 step 10
    const start = 2;
    const end = 70;
    const step = 2;
    const arrayLength = Math.floor((end - start) / step) + 1;
    const range = [...Array(arrayLength).keys()].map((x) => x * step + start);
    return range;
};
const fontSizes = fontPixels();
const StyledImage = styled("img")({
    boxShadow: "5px 5px 10px 0px rgba(0, 0, 0, 0.5)"
});

const MbSketchPicker = ({
    name,
    color,
    onChangeColor,
    showPicker,
    setShowPicker
}) => {
    return (
        <Box sx={{ position: "relative" }}>
            {showPicker && (
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        zIndex: "2"
                    }}
                >
                    <div
                        style={{
                            position: "fixed",
                            top: "0px",
                            right: "0px",
                            bottom: "0px",
                            left: "0px"
                        }}
                        onClick={() => setShowPicker(false)}
                    />
                    <SketchPicker
                        color={color}
                        name={name}
                        onChange={(updatedColor) => onChangeColor(updatedColor)}
                    />
                </div>
            )}
        </Box>
    );
};

function BrandingTab({
    styles,
    brandingStates,
    brandingStatesChangeHandler,
    setBrandingStates,
    domainStates,
    domainStatesChangeHandler,
    fontNames,
    fromDashboard
}) {
    const largerScreen = useMediaQuery("(min-width:500px)");
    const [showPrimaryColorPicker, setShowPrimaryColorPicker] = useState(false);
    const [showFontColorPicker, setShowFontColorPicker] = useState(false);
    const [showButtonColorPicker, setShowButtonColorPicker] = useState(false);
    const [showButtonTextColorPicker, setShowButtonTextColorPicker] =
        useState(false);
    const [showBackgroundColorPicker, setShowBackgroundColorPicker] =
        useState(false);

    const chipStyles = {
        width: "48px",
        height: "20px"
    };

    return (
        <>
            <Grid item variant="subHeading">
                <Typography variant="largerSubHeading">Styling</Typography>
            </Grid>
            <Grid item variant={"subHeading-divider"}>
                <Divider />
            </Grid>
            <Grid
                container
                item
                xs={12}
                sm={12}
                sx={{ paddingTop: "0px !important" }}
            >
                <Grid
                    container
                    item
                    spacing={2.25}
                    xs={12}
                    justifyContent="flex-start"
                >
                    <Grid item xs={12} sm={3}>
                        <FormControl fullWidth>
                            <TextField
                                size="small"
                                variant="outlined"
                                label="Primary brand color"
                                name="primaryColor"
                                value={brandingStates.primaryColor}
                                onChange={brandingStatesChangeHandler}
                                InputProps={{
                                    endAdornment: (
                                        <Chip
                                            variant="outlined"
                                            style={{
                                                ...chipStyles,
                                                backgroundColor:
                                                    brandingStates.primaryColor,
                                                borderRadius: "4px"
                                            }}
                                            onClick={() =>
                                                setShowPrimaryColorPicker(
                                                    !showPrimaryColorPicker
                                                )
                                            }
                                        />
                                    )
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={3}
                        sx={{ paddingLeft: "9px !important" }}
                    >
                        <InfoTooltip title="Main accent color for all elements on your online booking page, including buttons, icons, etc" />
                    </Grid>
                    <Grid item xs={12} sm={3} />
                    <Grid item xs={12} sm={3} />
                    <MbSketchPicker
                        color={brandingStates.primaryColor}
                        name="primaryColor"
                        onChangeColor={(updatedColor) =>
                            setBrandingStates((prevState) => {
                                return {
                                    ...prevState,
                                    primaryColor: updatedColor.hex
                                };
                            })
                        }
                        showPicker={showPrimaryColorPicker}
                        setShowPicker={setShowPrimaryColorPicker}
                    />
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
                <>
                    <Grid container spacing={2.25} sx={{ minWidth: "696px" }}>
                        <Grid item xs={12} sm={3}>
                            <FormControl fullWidth>
                                <InputLabel>Font Type</InputLabel>
                                <Select
                                    id="header-text"
                                    label="Font Type"
                                    variant="outlined"
                                    disableUnderline
                                    value={brandingStates.headerFontType}
                                    name={"headerFontType"}
                                    onChange={brandingStatesChangeHandler}
                                    InputProps={{ shrink: false }}
                                >
                                    {fontNames.map((name) => (
                                        <MenuItem
                                            key={name}
                                            value={name.toString()}
                                        >
                                            <span style={{ fontFamily: name }}>
                                                {name}
                                            </span>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                variant="outlined"
                                label="Font color"
                                name="headerFontColor"
                                value={brandingStates.headerFontColor}
                                onChange={brandingStatesChangeHandler}
                                InputProps={{
                                    endAdornment: (
                                        <Chip
                                            variant="outlined"
                                            style={{
                                                ...chipStyles,
                                                backgroundColor:
                                                    brandingStates.headerFontColor,
                                                borderRadius: "4px"
                                            }}
                                            onClick={() =>
                                                setShowFontColorPicker(
                                                    !showFontColorPicker
                                                )
                                            }
                                        />
                                    )
                                }}
                            />

                            <MbSketchPicker
                                color={brandingStates.headerFontColor}
                                name="headerFontColor"
                                onChangeColor={(updatedColor) =>
                                    setBrandingStates((prevState) => {
                                        return {
                                            ...prevState,
                                            headerFontColor: updatedColor.hex
                                        };
                                    })
                                }
                                showPicker={showFontColorPicker}
                                setShowPicker={setShowFontColorPicker}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                variant="outlined"
                                label="Button color"
                                name="buttonColor"
                                value={brandingStates.buttonColor}
                                onChange={brandingStatesChangeHandler}
                                InputProps={{
                                    endAdornment: (
                                        <Chip
                                            variant="outlined"
                                            style={{
                                                ...chipStyles,
                                                backgroundColor:
                                                    brandingStates.buttonColor,
                                                borderRadius: "4px"
                                            }}
                                            onClick={() =>
                                                setShowButtonColorPicker(
                                                    !showButtonColorPicker
                                                )
                                            }
                                        />
                                    )
                                }}
                            />

                            <MbSketchPicker
                                color={brandingStates.buttonColor}
                                name="buttonColor"
                                onChangeColor={(updatedColor) =>
                                    setBrandingStates((prevState) => {
                                        return {
                                            ...prevState,
                                            buttonColor: updatedColor.hex
                                        };
                                    })
                                }
                                showPicker={showButtonColorPicker}
                                setShowPicker={setShowButtonColorPicker}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                variant="outlined"
                                label="Button font color"
                                name="buttonTextColor"
                                value={
                                    brandingStates.buttonTextColor ||
                                    defaultBrandingStates.buttonTextColor
                                }
                                onChange={brandingStatesChangeHandler}
                                InputProps={{
                                    endAdornment: (
                                        <Chip
                                            variant="outlined"
                                            style={{
                                                ...chipStyles,
                                                backgroundColor:
                                                    brandingStates.buttonTextColor ||
                                                    defaultBrandingStates.buttonTextColor,
                                                borderRadius: "4px"
                                            }}
                                            onClick={() =>
                                                setShowButtonTextColorPicker(
                                                    !showButtonTextColorPicker
                                                )
                                            }
                                        />
                                    )
                                }}
                            />

                            <MbSketchPicker
                                color={brandingStates.buttonTextColor}
                                name="buttonTextColor"
                                onChangeColor={(updatedColor) =>
                                    setBrandingStates((prevState) => {
                                        return {
                                            ...prevState,
                                            buttonTextColor: updatedColor.hex
                                        };
                                    })
                                }
                                showPicker={showButtonTextColorPicker}
                                setShowPicker={setShowButtonTextColorPicker}
                            />
                        </Grid>
                    </Grid>
                </>
            </Grid>
            <Grid item variant="subHeading">
                <Typography variant="largerSubHeading">Header</Typography>
            </Grid>
            <Grid item variant={"subHeading-divider"}>
                <Divider />
            </Grid>
            <Grid item xs={12} sm={12}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={brandingStates.displayNameNextToLogo}
                            onChange={brandingStatesChangeHandler}
                            name="displayNameNextToLogo"
                            color="primary"
                            inputProps={{
                                "aria-label": "primary checkbox"
                            }}
                        />
                    }
                    label="Display company name next to company logo"
                />
            </Grid>

            <Grid item xs={12} sm={12}>
                <Box>
                    <FormControlLabel
                        sx={{ marginBottom: "0px", marginRight: "9px" }}
                        control={
                            <Switch
                                checked={brandingStates.showLogo}
                                onChange={brandingStatesChangeHandler}
                                name="showLogo"
                                color="primary"
                            />
                        }
                        label="Display company logo"
                    />
                    {
                        <ImageTooltip
                            content={
                                <StyledImage
                                    src={bookingFlowLogo}
                                    alt="Booking flow logo"
                                    width={400}
                                />
                            }
                        >
                            <QuestionMarkIcon
                                color="primary"
                                sx={getToolTipStyle()}
                            />
                        </ImageTooltip>
                    }
                </Box>
            </Grid>

            {brandingStates.showLogo && (
                <>
                    <Grid item xs={12} sm={12}>
                        <img
                            width={80}
                            height={80}
                            src={
                                !!brandingStates.logoURL
                                    ? brandingStates.logoURL
                                    : uploadImage
                            }
                            alt="Upload"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                let url =
                                    domainStates?.homepageURL?.length > 0
                                        ? `https://${domainStates.homepageURL}`
                                        : "https://www.gomarketbox.com/";
                                window.open(url, "_blank");
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} sx={{ maxHeight: "54px" }}>
                        <input
                            accept="image/*"
                            id="logoURL"
                            style={{ display: "none" }}
                            type="file"
                            onChange={brandingStatesChangeHandler}
                            name="logoURL"
                        />
                        <label htmlFor="logoURL">
                            <FormControl required>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component="span"
                                >
                                    Upload logo image
                                </Button>
                            </FormControl>
                        </label>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <TextField
                            sx={{ width: "50%", paddingRight: "9px" }}
                            variant="outlined"
                            InputProps={{
                                shrink: false,
                                disableUnderline: true,
                                startAdornment: (
                                    <InputAdornment
                                        sx={{
                                            color: "rgba(0,0,0,0.47)",
                                            fontFamily: "Roboto"
                                        }}
                                        position="start"
                                    >
                                        <span
                                            style={{
                                                color: "rgba(0,0,0,0.47)",
                                                fontFamily: "Roboto"
                                            }}
                                        >
                                            https://
                                        </span>
                                    </InputAdornment>
                                )
                            }}
                            label="Clickable logo URL"
                            name={"homepageURL"}
                            value={
                                domainStates?.homepageURL?.length > 0
                                    ? domainStates.homepageURL
                                    : ""
                            }
                            onChange={domainStatesChangeHandler}
                        />
                    </Grid>
                </>
            )}

            <Grid item xs={12} sm={12} direction={"row"}>
                <FormControlLabel
                    sx={{ marginBottom: "0px" }}
                    control={
                        <Switch
                            checked={brandingStates.showHeader}
                            onChange={brandingStatesChangeHandler}
                            name="showHeader"
                        />
                    }
                    label="Display background image"
                />
            </Grid>

            {/* Header Starts Here */}
            {brandingStates.showHeader && (
                <>
                    <Grid item xs={12} sm={12}>
                        <div
                            style={{
                                position: "relative",
                                display: "inline-block"
                            }}
                        >
                            <img
                                maxWidth={largerScreen ? 750 : 150}
                                height={largerScreen ? 175 : 80}
                                src={
                                    !!brandingStates.backgroundURL
                                        ? brandingStates.backgroundURL
                                        : uploadImage
                                }
                                alt="Upload"
                            />
                            <div
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    backgroundColor:
                                        brandingStates.backgroundColor,
                                    opacity:
                                        1 - brandingStates.headerTransparency // Adjust the opacity as desired
                                }}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <input
                            accept="image/*"
                            id="backgroundURL"
                            style={{ display: "none" }}
                            type="file"
                            onChange={brandingStatesChangeHandler}
                            name="backgroundURL"
                        />
                        <label htmlFor="backgroundURL">
                            <FormControl required>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component="span"
                                >
                                    Upload background image
                                </Button>
                            </FormControl>
                        </label>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Grid
                            container
                            item
                            spacing={2.25}
                            xs={12}
                            justifyContent="flex-start"
                        >
                            {!fromDashboard() && (
                                <Grid item xs={12} sm={3}>
                                    <FormControl>
                                        <TextField
                                            size="small"
                                            variant="outlined"
                                            id="backgroundcolor"
                                            label="Background color"
                                            name="backgroundColor"
                                            value={
                                                brandingStates.backgroundColor
                                            }
                                            onChange={
                                                brandingStatesChangeHandler
                                            }
                                            InputProps={{
                                                endAdornment: (
                                                    <Chip
                                                        variant="outlined"
                                                        style={{
                                                            ...chipStyles,
                                                            backgroundColor:
                                                                brandingStates.backgroundColor,
                                                            borderRadius: "4px"
                                                        }}
                                                        onClick={() =>
                                                            setShowBackgroundColorPicker(
                                                                !showBackgroundColorPicker
                                                            )
                                                        }
                                                    />
                                                )
                                            }}
                                        />
                                    </FormControl>

                                    <MbSketchPicker
                                        color={brandingStates.backgroundColor}
                                        name="backgroundColor"
                                        onChangeColor={(updatedColor) =>
                                            setBrandingStates((prevState) => {
                                                return {
                                                    ...prevState,
                                                    backgroundColor:
                                                        updatedColor.hex
                                                };
                                            })
                                        }
                                        showPicker={showBackgroundColorPicker}
                                        setShowPicker={
                                            setShowBackgroundColorPicker
                                        }
                                    />
                                </Grid>
                            )}
                            {!fromDashboard() && (
                                <Grid item xs={12} sm={3}>
                                    {brandingStates.showHeader && (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column"
                                            }}
                                        >
                                            <FormControl>
                                                <InputLabel>
                                                    Transparency
                                                </InputLabel>
                                                <Select
                                                    label="Transparency"
                                                    variant="outlined"
                                                    name={"headerTransparency"}
                                                    value={
                                                        brandingStates.headerTransparency
                                                    }
                                                    onChange={
                                                        brandingStatesChangeHandler
                                                    }
                                                >
                                                    {[...Array(11).keys()].map(
                                                        (i) => {
                                                            const value = (
                                                                i * 0.1
                                                            ).toFixed(1);
                                                            return (
                                                                <MenuItem
                                                                    key={value}
                                                                    value={
                                                                        value
                                                                    }
                                                                >
                                                                    {`${
                                                                        value *
                                                                        100
                                                                    }%`}
                                                                </MenuItem>
                                                            );
                                                        }
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    )}
                                </Grid>
                            )}
                            <Grid item xs={12} sm={3} />
                            <Grid item xs={12} sm={3} />
                        </Grid>
                    </Grid>
                </>
            )}

            <Grid item xs={12} sm={12}>
                <Box sx={{ mb: "12px" }}>
                    <FormControlLabel
                        sx={{ marginBottom: "0px", marginRight: "9px" }}
                        control={
                            <Switch
                                checked={brandingStates.showHeadingOne}
                                onChange={brandingStatesChangeHandler}
                                name="showHeadingOne"
                                color="primary"
                            />
                        }
                        label="Display heading 1"
                    />
                    {
                        <ImageTooltip
                            content={
                                <StyledImage
                                    src={bookingFlowHeadingOne}
                                    alt="Booking flow logo"
                                    width={400}
                                />
                            }
                        >
                            <QuestionMarkIcon
                                color="primary"
                                sx={getToolTipStyle()}
                            />
                        </ImageTooltip>
                    }
                </Box>
                {brandingStates.showHeadingOne && (
                    <Box>
                        <Grid container spacing={2.25}>
                            <Grid item xs={12} md={10.2}>
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                        disableUnderline: true
                                    }}
                                    label="Heading 1"
                                    id="heading-1"
                                    name={"companyName"}
                                    value={brandingStates.companyName}
                                    onChange={brandingStatesChangeHandler}
                                    onClick={() => {
                                        const heading1 =
                                            document.getElementById(
                                                "heading-1"
                                            );
                                        heading1.focus();
                                        heading1.select();
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={1.8}>
                                <FormControl>
                                    <InputLabel>Font size</InputLabel>
                                    <Select
                                        id="company-font-size"
                                        label="Font size"
                                        variant="outlined"
                                        disableUnderline
                                        fullWidth
                                        value={
                                            +brandingStates.companyNameFontSize
                                        }
                                        name={"companyNameFontSize"}
                                        onChange={brandingStatesChangeHandler}
                                        InputProps={{ shrink: false }}
                                    >
                                        {fontSizes.map((size) => (
                                            <MenuItem
                                                key={size}
                                                value={+size}
                                            >{`${size}px`}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Box>
                )}
            </Grid>

            <Grid item xs={12} sm={12}>
                <Box sx={{ mb: "12px" }}>
                    <FormControlLabel
                        sx={{ marginBottom: "0px", marginRight: "9px" }}
                        control={
                            <Switch
                                checked={brandingStates.showHeadingTwo}
                                onChange={brandingStatesChangeHandler}
                                name="showHeadingTwo"
                                color="primary"
                            />
                        }
                        label="Display heading 2"
                    />
                    {
                        <ImageTooltip
                            content={
                                <StyledImage
                                    src={bookingFlowHeadingTwo}
                                    alt="Booking Flow Heading 2"
                                    width={400}
                                />
                            }
                        >
                            <QuestionMarkIcon
                                color="primary"
                                sx={getToolTipStyle()}
                            />
                        </ImageTooltip>
                    }
                </Box>
                {brandingStates.showHeadingTwo && (
                    <Box>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={10.2}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                        disableUnderline: true
                                    }}
                                    label="Heading 2"
                                    name={"companyTagline"}
                                    id="heading-2"
                                    value={brandingStates.companyTagline}
                                    onChange={brandingStatesChangeHandler}
                                    onClick={() => {
                                        const heading2 =
                                            document.getElementById(
                                                "heading-2"
                                            );
                                        heading2.focus();
                                        heading2.select();
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={1.8}>
                                <FormControl>
                                    <InputLabel>Font size</InputLabel>
                                    <Select
                                        id="company-font-size"
                                        label="Font size"
                                        variant="outlined"
                                        disableUnderline
                                        fullWidth
                                        name={"companyTaglineFontSize"}
                                        value={
                                            +brandingStates.companyTaglineFontSize
                                        }
                                        onChange={brandingStatesChangeHandler}
                                        InputProps={{ shrink: false }}
                                    >
                                        {fontSizes.map((size) => (
                                            <MenuItem
                                                key={size}
                                                value={+size}
                                            >{`${size}px`}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Box>
                )}
            </Grid>
            <Grid item xs={12} sm={12}>
                <Box sx={{ mb: "12px" }}>
                    <FormControlLabel
                        sx={{ marginBottom: "0px", marginRight: "9px" }}
                        control={
                            <Switch
                                name={"showHeadingThree"}
                                checked={brandingStates.showHeadingThree}
                                onChange={brandingStatesChangeHandler}
                                color="primary"
                            />
                        }
                        label="Display heading 3"
                    />
                    {
                        <ImageTooltip
                            content={
                                <StyledImage
                                    src={bookingFlowHeadingThree}
                                    alt="Booking Flow Heading 3"
                                    width={400}
                                />
                            }
                        >
                            <QuestionMarkIcon
                                color="primary"
                                sx={getToolTipStyle()}
                            />
                        </ImageTooltip>
                    }
                </Box>
                {brandingStates.showHeadingThree && (
                    <Box>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={10.2}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                        disableUnderline: true
                                    }}
                                    label="Heading 3"
                                    id="heading-3"
                                    name={"companyDescription"}
                                    value={brandingStates.companyDescription}
                                    onChange={brandingStatesChangeHandler}
                                    onClick={() => {
                                        const heading3 =
                                            document.getElementById(
                                                "heading-3"
                                            );
                                        heading3.focus();
                                        heading3.select();
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={1.8}>
                                <FormControl>
                                    <InputLabel>Font size</InputLabel>
                                    <Select
                                        id="company-font-size"
                                        label="Font size"
                                        variant="outlined"
                                        disableUnderline
                                        fullWidth
                                        name={"companyDescriptionFontSize"}
                                        InputProps={{ shrink: false }}
                                        value={
                                            +brandingStates.companyDescriptionFontSize
                                        }
                                        onChange={brandingStatesChangeHandler}
                                    >
                                        {fontSizes.map((size) => (
                                            <MenuItem
                                                key={size}
                                                value={+size}
                                            >{`${size}px`}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Box>
                )}
            </Grid>
        </>
    );
}

export default BrandingTab;
